<lib-adyen-payment
  *ngIf="checkout"
  [checkout]="checkout"
  [isAdvancedFlow]="isAdvancedFlow"
  [adyenOrderType]="adyenOrderType"
  (onPaymentCompleted)="onPaymentCompleted($event)"
  (onPaymentFailed)="onPaymentFailed($event)"
></lib-adyen-payment>
